import { StyleSheet } from 'react-native'

export const CARD_GAP = 16

export const friendsGridStyles = StyleSheet.create({
  flashList: {
    width: '100%',
  },
  cardContainerLastInRow: {
    marginRight: 0,
  },
  cardContainerNotLastInRow: {
    marginRight: CARD_GAP,
  },
})

const flashListStyleCache = new Map<number, ReturnType<typeof StyleSheet.create>[string]>()
const cardContainerStyleCache = new Map<number, ReturnType<typeof StyleSheet.create>[string]>()

/** Dynamic width for FlashList (screen width). Cached to avoid creating new StyleSheet objects per render. */
export const getFlashListStyle = (screenWidth: number) => {
  const cached = flashListStyleCache.get(screenWidth)
  if (cached) return cached
  const style = StyleSheet.create({
    flashListWidth: { width: screenWidth },
  }).flashListWidth
  flashListStyleCache.set(screenWidth, style)
  return style
}

/** Card container width and bottom margin. Cached to avoid creating new StyleSheet objects per render. */
export const getCardContainerStyle = (cardWidth: number) => {
  const rounded = Math.round(cardWidth * 100) / 100
  const cached = cardContainerStyleCache.get(rounded)
  if (cached) return cached
  const style = StyleSheet.create({
    cardContainer: { width: rounded, marginBottom: CARD_GAP },
  }).cardContainer
  cardContainerStyleCache.set(rounded, style)
  return style
}

